// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__LoEAi","header":"MessagesList_header__2981O","chat":"MessagesList_chat__3ZLbe"};